import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useMe } from '../../organisation/useMe';
import { caseNoteInternalApi } from '../../apis';

export const CASE_NOTES_QUERY_KEY = 'caseNotes';

export const useQueryCaseNotes = (handle: string) => {
  const { currentOrganisation } = useMe();

  return useQuery({
    queryKey: [CASE_NOTES_QUERY_KEY, handle, currentOrganisation?.id],
    queryFn: async () => {
      return await caseNoteInternalApi.findCaseNotes({ handle });
    },
    enabled: !!currentOrganisation?.id && !!handle,
  });
};

export const useCreateCaseNote = (handle: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ content, draftId }: { content: string; draftId?: number }) => {
      return caseNoteInternalApi.createCaseNote({
        handle,
        internalApiCreateInvestigationNote: { content, draftId },
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [CASE_NOTES_QUERY_KEY] });
    },
  });
};
